/* ============================================================
   Swap til stål · tidlig adgang (faelles for hele sitet)

   Kernen (snippets/yy-ta-kerne.liquid) har allerede regnet fasen ud og
   sat window.YYTA. Her bor det, der kan vente til siden er tegnet:

   - status:   er det loggede-ind medlem paa listen? (caches 10 min)
   - tilmeld:  [data-ta-tilmeld] i en [data-ta-boks] med evt.
               [data-ta-samtykke]. Uden klub-session gemmes et ønske,
               og man sendes til klubbens login. Naar klubben har logget
               en ind, fuldfoeres tilmeldingen her, og man sendes tilbage
               til landingssiden.
   - Lead:     fyres KUN ved en ny tilmelding, i browseren og via
               meta-capi med samme event_id. content_name adskiller
               klubtilmeldinger fra 31 ting og quizzen.
   - nedtaelling: [data-ta-nedtael="slut|tidlig|offentlig|kampagneSlut"]
   - kurv:     [data-ta-kurv data-variant] paa landingssidens saet.
   ============================================================ */
(function () {
  var Y = window.YYTA;
  if (!Y) return;
  var T = Y.t;
  var OENSKE = 'yyta_oenske';
  var NAVN = 'Klub · tidlig adgang';

  function sid() { try { return localStorage.getItem('yyk_session') || ''; } catch (e) { return ''; } }
  function gemStatus(t) {
    try { localStorage.setItem('yyta_status', JSON.stringify({ sid: sid(), tilmeldt: !!t, ts: Date.now() })); } catch (e) {}
  }
  function saetTilmeldt(t) {
    if (Y.medlemTest) return;
    Y.tilmeldt = !!t;
    Y.vis();
    document.dispatchEvent(new CustomEvent('yyta:status', { detail: { tilmeldt: Y.tilmeldt } }));
  }

  function kald(handling, ekstra) {
    var krop = { sid: sid(), handling: handling };
    for (var k in (ekstra || {})) krop[k] = ekstra[k];
    return fetch(Y.fn, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(krop) })
      .then(function (r) {
        return r.json().catch(function () { return { ok: false }; })
          .then(function (j) { j._status = r.status; return j; });
      });
  }

  function lokal() { try { return localStorage.getItem('yyta_lokal') === '1'; } catch (e) { return false; } }
  function opdaterStatus(tving) {
    if (!sid()) { saetTilmeldt(lokal()); return Promise.resolve(); }
    if (!tving) {
      try {
        var c = JSON.parse(localStorage.getItem('yyta_status') || 'null');
        if (c && c.sid === sid() && Date.now() - c.ts < 600000) { saetTilmeldt(c.tilmeldt); return Promise.resolve(); }
      } catch (e) {}
    }
    return kald('status').then(function (j) {
      if (j._status === 401) { saetTilmeldt(false); return; }
      if (j.ok) { gemStatus(j.tilmeldt); saetTilmeldt(j.tilmeldt || lokal()); }
    }).catch(function () {});
  }

  /* ---------- Meta ---------- */
  function cookie(n) {
    try { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; }
    catch (e) { return ''; }
  }
  function fbc() {
    var c = cookie('_fbc'); if (c) return c;
    try { var id = new URLSearchParams(location.search).get('fbclid'); return id ? 'fb.1.' + Date.now() + '.' + id : ''; }
    catch (e) { return ''; }
  }
  function sha256(s) {
    try {
      return crypto.subtle.digest('SHA-256', new TextEncoder().encode(String(s).trim().toLowerCase()))
        .then(function (h) { return Array.from(new Uint8Array(h)).map(function (x) { return x.toString(16).padStart(2, '0'); }).join(''); })
        .catch(function () { return ''; });
    } catch (e) { return Promise.resolve(''); }
  }
  function uuid() {
    try { if (crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'ta-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10);
  }
  function meld(eventId, em, kilde, ekstra) {
    try {
      if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: NAVN, content_category: 'klub tidlig adgang' }, { eventID: eventId });
    } catch (e) {}
    var vid = cookie('yy_vid');
    return (vid ? sha256(vid) : Promise.resolve('')).then(function (ext) {
      return fetch(Y.capi, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_name: 'Lead', event_id: eventId, em: em || '', external_id: ext,
          fn: (ekstra && ekstra.fn) || '', ph: (ekstra && ekstra.ph) || '',
          fbp: cookie('_fbp'), fbc: fbc(), event_source_url: location.href,
          content_name: NAVN + ' · ' + kilde, content_category: 'klub tidlig adgang'
        })
      }).catch(function () {});
    });
  }

  /* ---------- tilmelding ---------- */
  function boksFejl(boks, tekst) {
    var f = boks && boks.querySelector('[data-ta-fejl]');
    if (!f) return;
    f.textContent = tekst || '';
    f.hidden = !tekst;
  }

  function tilmeld(kilde, samtykke, knap, boks) {
    var eventId = uuid();
    var tekst = knap ? knap.textContent : '';
    if (knap) { knap.disabled = true; knap.setAttribute('aria-busy', 'true'); knap.textContent = T.sender; }
    boksFejl(boks, '');
    return kald('tilmeld', { samtykke: !!samtykke, kilde: kilde, event_id: eventId }).then(function (j) {
      if (j.ok) {
        gemStatus(true);
        saetTilmeldt(true);
        document.dispatchEvent(new CustomEvent('yyta:tilmeldt', { detail: j }));
        return (j.ny ? meld(eventId, j.em, kilde) : Promise.resolve()).then(function () { return j; });
      }
      if (j._status === 401) { tilLogin(kilde, samtykke); return j; }
      boksFejl(boks, j.fejl === 'lukket' ? T.lukket : T.fejl);
      return j;
    }).catch(function () {
      boksFejl(boks, T.fejl);
      return { ok: false };
    }).then(function (j) {
      if (knap) { knap.disabled = false; knap.removeAttribute('aria-busy'); knap.textContent = tekst; }
      return j;
    });
  }

  /* Log ind via klubben (eksisterende medlemmer): ønsket gemmes og
     fuldfoeres, naar klubben har logget en ind. */
  function tilLogin(kilde, samtykke) {
    try { localStorage.setItem(OENSKE, JSON.stringify({ kilde: kilde, samtykke: !!samtykke, ts: Date.now() })); } catch (e) {}
    location.href = Y.klub + '?ta=1';
  }
  /* Uden klub-session: til landingssidens formular (navn, e-mail, mobil).
     Paa landingssiden selv: hop til formularen. */
  function paaLp() { return location.pathname.replace(/\/+$/, '') === (Y.lp || '').replace(/\/+$/, ''); }
  function tilFormular(kilde) {
    var f = document.querySelector('[data-ta-form]');
    if (paaLp() && f) {
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var i = f.querySelector('input'); if (i) setTimeout(function () { i.focus({ preventScroll: true }); }, 450);
      return;
    }
    location.href = Y.lp + '?kilde=' + encodeURIComponent(kilde || 'ukendt') + '#tilmeld';
  }

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ta-tilmeld]');
    if (!k) return;
    e.preventDefault();
    var boks = k.closest('[data-ta-boks]');
    var sam = boks && boks.querySelector('[data-ta-samtykke]');
    var samtykke = !!(sam && sam.checked);
    var kilde = k.getAttribute('data-ta-kilde') || (boks && boks.getAttribute('data-ta-kilde')) || 'ukendt';
    if (!sid()) { tilFormular(kilde); return; }
    tilmeld(kilde, samtykke, k, boks);
  });

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ta-login]');
    if (!k) return;
    e.preventDefault();
    tilLogin(k.getAttribute('data-ta-kilde') || 'lp', false);
  });
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ta-hop]');
    if (!k) return;
    e.preventDefault();
    if (sid()) { var b = document.querySelector('.ta-ea__ind [data-ta-tilmeld]'); if (b) { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } }
    tilFormular('lp');
  });

  /* ---------- landingssidens formular ---------- */
  var GYLDIG = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ta-form]');
    if (!f) return;
    e.preventDefault();
    var fejl = f.querySelector('[data-ta-fejl]');
    function sig(t) { if (fejl) { fejl.textContent = t || ''; fejl.hidden = !t; } }
    var v = function (n) { var el = f.querySelector('[name="' + n + '"]'); return el ? (el.type === 'checkbox' ? el.checked : el.value.trim()) : ''; };
    var data = { fornavn: v('fornavn'), email: v('email'), telefon: v('telefon'), samtykke: v('samtykke'), sms: v('sms') };
    if (!data.fornavn) return sig(T.err_navn);
    if (!GYLDIG.test(data.email)) return sig(T.err_email);
    if (!data.samtykke) return sig(T.err_samtykke);
    sig('');
    var knap = f.querySelector('button[type="submit"]'), tekst = knap ? knap.innerHTML : '';
    if (knap) { knap.disabled = true; knap.textContent = T.sender; }
    var eventId = uuid();
    var kilde = 'lp';
    try { kilde = new URLSearchParams(location.search).get('kilde') || 'lp'; } catch (x) {}
    fetch(Y.fn, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ handling: 'tilmeld_email', email: data.email, fornavn: data.fornavn, telefon: data.telefon,
        samtykke: !!data.samtykke, sms: !!data.sms, kilde: kilde, event_id: eventId })
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); }).then(function (j) {
      if (!j.ok) { sig(j.fejl === 'lukket' ? T.lukket : j.fejl === 'email' ? T.err_email : T.fejl); return; }
      try { localStorage.setItem('yyta_lokal', '1'); } catch (x) {}
      Y.lokal = true;
      saetTilmeldt(true);
      var ph = (data.telefon || '').replace(/[^\d]/g, '');
      if (ph.length === 8) ph = '45' + ph;
      Promise.all([sha256(data.email), sha256(data.fornavn), ph ? sha256(ph) : Promise.resolve('')]).then(function (h) {
        if (j.ny) meld(eventId, h[0], kilde, { fn: h[1], ph: h[2] });
      });
      document.dispatchEvent(new CustomEvent('yyta:tilmeldt', { detail: j }));
      var tak = document.querySelector('[data-ta-tak]');
      if (tak) tak.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }).catch(function () { sig(T.fejl); }).then(function () {
      if (knap) { knap.disabled = false; knap.innerHTML = tekst; }
    });
  });

  /* ---------- kalender (.ics) ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ta-kal]');
    if (!k) return;
    e.preventDefault();
    function dato(t) { return new Date(t).toLocaleDateString('sv-SE', { timeZone: 'Europe/Copenhagen' }).replace(/-/g, ''); }
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Yummii Yummii//Klub//DA', 'BEGIN:VEVENT',
      'UID:tidlig-adgang-' + dato(Y.d.tidlig) + '@yummiiyummii.dk',
      'DTSTART;VALUE=DATE:' + dato(Y.d.tidlig), 'DTEND;VALUE=DATE:' + dato(Y.d.offentlig),
      'SUMMARY:' + T.kal_titel, 'DESCRIPTION:' + T.kal_tekst + ' ' + location.origin + Y.lp,
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    var a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
    a.download = 'klub-yummii-tidlig-adgang.ics';
    document.body.appendChild(a); a.click(); a.remove();
  });

  /* Et ønske fra foer login. Klubsiden logger ind asynkront (?code= ->
     club_login -> yyk_session), saa vi venter paa sessionen i op til et
     minut i stedet for at blande os i klubbens egen kode. */
  function laesOenske() {
    try {
      var o = JSON.parse(localStorage.getItem(OENSKE) || 'null');
      if (o && Date.now() - o.ts < 2 * 3600 * 1000) return o;
      localStorage.removeItem(OENSKE);
    } catch (e) {}
    return null;
  }
  function fuldfoerOenske() {
    var o = laesOenske();
    if (!o) return;
    var paaKlub = /^\/pages\/klub/i.test(location.pathname);
    if (paaKlub) document.querySelectorAll('[data-ta-gate]').forEach(function (el) { el.hidden = false; });
    var forsoeg = 0;
    (function vent() {
      if (sid()) {
        try { localStorage.removeItem(OENSKE); } catch (e) {}
        tilmeld(o.kilde, o.samtykke, null, null).then(function (j) {
          if (j && j.ok && paaKlub) location.href = Y.lp + (Y.lp.indexOf('?') > -1 ? '&' : '?') + 'tilmeldt=1';
        });
        return;
      }
      if (paaKlub && ++forsoeg < 120) setTimeout(vent, 500);
    })();
  }

  /* ---------- nedtaelling ---------- */
  function to(n) { return (n < 10 ? '0' : '') + n; }
  function tael() {
    var nu = Date.now();
    document.querySelectorAll('[data-ta-nedtael]').forEach(function (el) {
      var maal = Y.d[el.getAttribute('data-ta-nedtael')];
      var r = Math.max(0, Math.floor((maal - nu) / 1000));
      var v = { d: Math.floor(r / 86400), t: Math.floor(r % 86400 / 3600), m: Math.floor(r % 3600 / 60), s: r % 60 };
      var kort = el.querySelector('[data-n-kort]');
      if (kort) kort.textContent = v.d > 0 ? v.d + ' ' + (v.d === 1 ? kort.dataset.dag : kort.dataset.dage) : v.t + ' t ' + v.m + ' m';
      el.querySelectorAll('[data-n]').forEach(function (x) {
        var k = x.getAttribute('data-n');
        x.textContent = k === 'd' ? v.d : to(v[k]);
      });
    });
  }

  /* ---------- kurv paa landingssiden ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-ta-kurv]');
    if (!k) return;
    e.preventDefault();
    var tekst = k.textContent;
    k.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +k.getAttribute('data-variant'), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('kurv');
      k.textContent = T.kurv_ok;
      if (window.yyCart) { window.yyCart.refresh && window.yyCart.refresh(); window.yyCart.open && window.yyCart.open(); }
    }).catch(function () {
      k.textContent = T.kurv_fejl;
    }).then(function () {
      setTimeout(function () { k.disabled = false; k.textContent = tekst; }, 2200);
    });
  });

  function start() {
    Y.vis();
    tael();
    if (document.querySelector('[data-ta-nedtael]')) setInterval(tael, 1000);
    opdaterStatus(false).then(fuldfoerOenske);
  }
  Y.opdaterStatus = opdaterStatus;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
